<div class="complete-data-container">
    <div *ngIf="currentQuestionPage" class="current-page">
        <div class="progress-container">
          <div class="progress-step active">
            <div class="progress-icon">1</div>
          </div>
          <div class="progress-line active"></div>
          <div [ngClass]="{ 'progress-step': true, 'active': currentQuestionPageIndex > 0 }">
            <div class="progress-icon">2</div>
          </div>
          <div [ngClass]="{ 'progress-line': true, 'active': currentQuestionPageIndex > 0 }"></div>
        </div>
        <!--div>{{currentQuestion}}</div-->
        <div class="form-container">
            <div *ngFor="let question of currentQuestionPage.questions; let i = index" class="question-container">
                <div class="question-title">
                  {{question.title}} 
                  <br *ngIf="question.subtitle != ''">
                  <span *ngIf="question.subtitle != ''" class="question-subtitle"> {{question.subtitle}}</span>
                </div>
                <div *ngIf="question.type == 'box'" class="answers-container">
                    <button *ngFor="let answer of question.answers"
                            class="answer-card"
                            [class.selected]="question.value === answer"
                            (click)="selectAnswer(answer, question)">
                        {{ answer }}
                    </button>
                </div>
                <div *ngIf="question.type === 'dropdown'" class="custom-dropdown" [class.open]="openDropdownIndex === i">
                  <div 
                    class="dropdown-toggle" 
                    (click)="toggleDropdown(i); $event.stopPropagation()"
                  >
                    {{ question.value || 'Selecciona una opción' }}
                    <span class="dropdown-arrow" [class.rotated]="openDropdownIndex === i"></span>
                  </div>
              
                  <div class="dropdown-menu" *ngIf="openDropdownIndex === i">
                    <div 
                      class="dropdown-item" 
                      *ngFor="let answer of question.answers"
                      (click)="selectAnswer(answer, question); $event.stopPropagation()"
                    >
                      {{ answer }}
                    </div>
                  </div>

                  <div *ngIf="question.otherAnswer && question.value === question.answers[question.answers.length - 1]" class="other-answer">
                    <input 
                      type="text" 
                      class="other-answer-input"
                      placeholder="Especifica tu respuesta"
                      [(ngModel)]="question.otherAnswerValue"
                    />
                  </div>
                </div>
            </div>
        </div>

        <button [disabled]="!areAllAnswered()" class="boton-principal" (click)="showWelcomeModal()">Continuar</button>
    </div>
</div>

<!-- Modal de bienvenida -->
<div *ngIf="showModal" class="modal-overlay" (click)="closeModal()">
    <div class="modal-container" (click)="$event.stopPropagation()">
        <div class="modal-content">
            <!-- Imagen de fondo del modal -->
            <div class="modal-header-image">
                <img src="/assets/img/office-meeting.jpg" alt="Escena profesional de oficina" class="modal-background-image" />
            </div>
            
            <!-- Contenido del modal -->
            <div class="modal-text-content">
                <!-- Mensaje de bienvenida -->
                <h2 class="welcome-title">Te damos la bienvenida {{ userName.split(' ')[0] || userName }}</h2>
                
                <!-- Texto explicativo -->
                <p class="welcome-text">
                    Descubre tu Rueda de la Vida: Conoce cómo te encuentras hoy, proyecta cómo imaginas tu futuro y recibe un diagnóstico que te guiará a dar tus próximos pasos. Vamos a empezar con <strong>tu presente.</strong>
                </p>
                
                <!-- Botón continuar -->
                <button class="modal-continue-btn" (click)="continueToNextForm()">Comenzar</button>
            </div>
        </div>
    </div>
</div>